<template>
    <div class="input-slider no-swiping">
        <div class="slider-value" style="margin-bottom: 8px;">
            {{ field.value }}
        </div>
        <Slider 
            :name="`${step.name}[${data.element_details.name}]`"
            :max="maxValue"
            :min="minValue"
            :step="stepValue"
            v-model="field.value"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
    data: Object,
    field: Object,
    step: Object,
})
const maxValue = computed(() => {
    return props.data.validators.find((el) => el.class == "Laminas\\Validator\\LessThan")?.max ?? 100;
})
const minValue = computed(() => {
    return props.data.validators.find((el) => el.class == "Laminas\\Validator\\GreaterThan")?.min ?? 0;
})
const stepValue = computed(() => {
    return props.data.validators.find((el) => el.class == "Laminas\\Validator\\Step")?.step ?? 5;
})

defineEmits(['update:modelValue'])
</script>